import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target, Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['✅ TOMO 1: Material de Aula', '✅ TOMO 2: Guías de Práctica de Campo', '✅ TOMO 3: Taller de Cálculo Planimétrico', '✅ TOMO 4: Laboratorio de Altimetría', '✅ TOMO 5: Módulo de Obra y GPS', '✅ TOMO 6: Topografía Digital', '🎁 BONO 1: Banco de Evaluaciones', '🎁 BONO 2: Banco de Actividades Prácticas', '🎁 BONO 3: Plantillas Excel de Cálculo Topográfico', '🎁 BONO 4: Glosario Técnico Ilustrado', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const maestroFeatures = ['✅ TOMO 1: Material de Aula', '✅ TOMO 2: Guías de Práctica de Campo', '✅ TOMO 3: Taller de Cálculo Planimétrico', '✅ TOMO 4: Laboratorio de Altimetría', '✅ TOMO 5: Módulo de Obra y GPS', '✅ TOMO 6: Topografía Digital', '🎁 BONO 1: Banco de Evaluaciones', '🎁 BONO 2: Banco de Actividades Prácticas', '🎁 BONO 3: Plantillas Excel de Cálculo Topográfico', '🎁 BONO 4: Glosario Técnico Ilustrado', '⚡ UPSELL: Megapack Topografía Listo — Presentaciones', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const comparisonRows = [{
    sit: 'Explicar nivelación geométrica',
    sin: 'Dibujás en el pizarrón improvisando',
    con: 'Diapositiva animada con esquema paso a paso'
  }, {
    sit: 'Presentar instrumental topográfico',
    sin: 'Mostrás fotos de Google',
    con: 'Slides profesionales con nomenclatura técnica'
  }, {
    sit: 'Clase de GPS RTK',
    sin: 'No tenés soporte visual',
    con: 'Presentación completa lista para proyectar'
  }, {
    sit: 'Revisión previa al parcial',
    sin: 'Armás el resumen la noche anterior',
    con: 'Slide de repaso ya armado con los puntos clave'
  }, {
    sit: 'Primera clase del año',
    sin: 'Hablás sin apoyo visual',
    con: 'Presentación de la asignatura lista'
  }, {
    sit: 'Práctica de Civil 3D',
    sin: 'Mostrás tu pantalla sin guía',
    con: 'Paso a paso visual proyectable para toda la clase'
  }];
  return <section id="pricing" className="py-24 bg-[#0c241a]" data-id="element-199">
      <div className="container mx-auto px-4" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-202">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-slate-300 text-[16px]" data-id="element-203">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-204">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#06140d] rounded-3xl p-8 shadow-2xl border border-[#1a3d2c] flex flex-col h-full relative z-10" data-id="element-205">
            <div className="mb-6" data-id="element-206">
              <p className="text-slate-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-207">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-208">
                📐 MEGAPACK TOPOGRAFÍA LISTO™
              </h3>
              <p className="text-slate-400 font-medium" data-id="element-209">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#1a3d2c]" data-id="element-210"></div>

            <div className="mb-8" data-id="element-211">
              <div className="flex items-end gap-2" data-id="element-212">
                <span className="text-5xl font-black text-white" data-id="element-213">$19.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-214">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-215">$45.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-216">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-217">
                  <span className="text-slate-300 text-[15px]" data-id="element-218">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47783438090434:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-219">
              <Button variant="outline" size="lg" fullWidth data-id="element-220">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#06140d] rounded-3xl p-8 shadow-2xl border-2 border-slate-300 flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-221">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-slate-200 text-slate-950 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-222">
              <Zap className="w-4 h-4 fill-slate-950" data-id="element-223" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-224">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-225">
                MEGAPACK + PRESENTACIONES LISTAS
              </h3>
              <p className="text-slate-300 font-bold" data-id="element-226">
                Todo lo anterior + Sistema Completo de Diapositivas
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-emerald-900/50" data-id="element-227"></div>

            <div className="mb-8" data-id="element-228">
              <div className="flex items-end gap-2" data-id="element-229">
                <span className="text-5xl font-black text-white" data-id="element-230">$27.990</span>
                <span className="text-xl font-bold text-slate-300 mb-1" data-id="element-231">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-232">$75.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-233">
              {maestroFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-234">
                  <Zap className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-235" />
                  <span className={i === 0 ? 'text-slate-200 font-bold' : 'text-slate-300'} data-id="element-236">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47783442383042:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-237">
              <Button variant="primary" size="lg" fullWidth data-id="element-238">
                ⚡ QUIERO EL MEGAPACK + PRESENTACIONES
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-slate-400 text-sm mb-20" data-id="element-239">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Pack Maestro Details */}
        <div className="max-w-4xl mx-auto" data-id="element-240">
          <div className="text-center mb-10" data-id="element-241">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-242">
              <Target className="w-8 h-8 text-slate-300" data-id="element-243" />
              🎯 ¿QUÉ AGREGA EL PACK DE PRESENTACIONES?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-244">
            <div className="min-w-[700px]" data-id="element-245">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-246">
                <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-247">
                  Situación
                </div>
                <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-248">
                  ❌ Sin Presentaciones
                </div>
                <div className="font-bold text-slate-300 uppercase text-sm tracking-wider" data-id="element-249">
                  ✅ Con Presentaciones
                </div>
              </div>

              <div className="space-y-2" data-id="element-250">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-[#06140d]/60 rounded-xl p-4 items-center border border-[#1a3d2c]" data-id="element-251">
                    <div className="text-slate-300 font-medium text-sm" data-id="element-252">
                      {row.sit}
                    </div>
                    <div className="text-red-300/80 text-sm" data-id="element-253">{row.sin}</div>
                    <div className="text-slate-200 font-medium text-sm" data-id="element-254">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-[#0a1f15]/50 rounded-2xl p-6 md:p-8 border border-[#1a3d2c]" data-id="element-255">
            <h4 className="font-bold text-slate-200 mb-6 uppercase tracking-wider" data-id="element-256">
              EL PACK DE PRESENTACIONES INCLUYE:
            </h4>
            <div className="space-y-6" data-id="element-257">
              <div data-id="element-258">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-259">
                  <span className="text-slate-300" data-id="element-260">📊</span> DIAPOSITIVAS
                  EDITABLES
                </p>
                <p className="text-slate-300 text-sm" data-id="element-261">
                  Presentaciones para cada tomo listas para proyectar. Podés
                  personalizarlas para tu cátedra y ahorrar horas de armado.
                </p>
              </div>
              <div data-id="element-262">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-263">
                  <span className="text-slate-300" data-id="element-264">📸</span> MATERIAL VISUAL
                  PREMIUM
                </p>
                <p className="text-slate-300 text-sm" data-id="element-265">
                  Imágenes de alta calidad para explicar instrumental
                  topográfico, esquemas de nivelación y casos de obra.
                </p>
              </div>
              <div data-id="element-266">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-267">
                  <span className="text-slate-300" data-id="element-268">💻</span> SLIDES DE SOFTWARE
                </p>
                <p className="text-slate-300 text-sm" data-id="element-269">
                  Paso a paso visual para enseñar Civil 3D, GPS y Topografía
                  Digital sin que los alumnos se pierdan en la pantalla.
                </p>
              </div>
              <div data-id="element-270">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-271">
                  <span className="text-slate-300" data-id="element-272">📝</span> PRESENTACIONES DE
                  REPASO
                </p>
                <p className="text-slate-300 text-sm" data-id="element-273">
                  Slides de evaluación y repaso ya armados con los puntos clave
                  para las clases previas a los parciales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}